import { useQuery } from "@tanstack/react-query";
import { StorageService } from "./_request";

export const useQueryStorageLoadState = (params?: any) => {
  return useQuery({
    queryKey: ["queryOTState"],
    queryFn: async () => StorageService.getStorageLoadStateSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
